// extracted by mini-css-extract-plugin
module.exports = {"setting":"WaterMirror_style_setting__bi1M0","title":"WaterMirror_style_title__3h-EU"};